import { render, staticRenderFns } from "./ReportsTransactionHistory.vue?vue&type=template&id=19047a9d&"
import script from "./ReportsTransactionHistory.vue?vue&type=script&lang=js&"
export * from "./ReportsTransactionHistory.vue?vue&type=script&lang=js&"
import style0 from "./ReportsTransactionHistory.vue?vue&type=style&index=0&id=19047a9d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports